import React, {useEffect, useState} from 'react'
import Vendors from '../../../../components/Project/Resources/Vendors/Vendors'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import {VendorsApi, remove as removeApi} from '../../../../api/Projects/Resources'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import useModalData from '../../../../elements/Hooks/useModalData'
import {message} from 'antd'

function VendorsCont(props) {
  const {project} = props
  const {list, fetching, fetch} = useFetchList(() =>
    VendorsApi.list(project._id, 'vendors'),
  )
  const {
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()

  const {
    visible,
    modalType,
    object: vendor,
    submitting,
    setSubmitting,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
    removing,
    remove,
  } = useModalData(VendorsApi.create, VendorsApi.update, removeApi, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await VendorsApi.create({...newObject, project})
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <Vendors
      {...{
        project,
        list,
        fetching,
        submitting,
        visible,
        fetch,
        vendor,
        onShow,
        onCancel,
        checkForm,
        submit,
        update,
        modalType,
        removing,
        remove,
        formRef,
        //selection
        selection,
        selectAll,
        setSelection,
        tableRef,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

VendorsCont.propTypes = {}
VendorsCont.defaultProps = {}

export default (VendorsCont)
